import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.min.css'
import 'dayjs/locale/zh-cn'; // 当时不加日期内部的年月没有汉化
import 'moment/locale/zh-cn';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);